export default {
  FETCH_SITE_FEATURES_REQUEST: 'FETCH_SITE_FEATURES_REQUEST',
  FETCH_SITE_FEATURES_SUCCESS: 'FETCH_SITE_FEATURES_SUCCESS',
  FETCH_SITE_FEATURES_FAILURE: 'FETCH_SITE_FEATURES_FAILURE'
}
